import { Memo, MemoType, hasTitle } from 'models/Memo';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './useFormInitialisation';
import { useToggleableField } from './useToggleableField';

interface Props {
  memo?: Memo;
  methods: UseFormReturn<FormValues>;
  selectedMemoType: MemoType;
}

export const useTitle = ({ memo, methods, selectedMemoType }: Props) => {
  const canShowTitle = [
    MemoType.Text,
    MemoType.Quote,
    MemoType.Link,
    MemoType.Doc,
    MemoType.TaskList,
    MemoType.Image,
    MemoType.Audio,
    MemoType.Video,
    MemoType.File,
  ].includes(selectedMemoType);

  const hasInitialValue = !!(memo && hasTitle(memo) && memo.title);

  const { isVisible, toggle } = useToggleableField({
    fieldName: 'title',
    methods,
    canShow: canShowTitle,
    hasInitialValue,
  });

  return {
    canShowTitle,
    isTitleVisible: isVisible,
    toggleTitle: toggle,
  };
};
